// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"520":"3479bb73","601":"b814aa70","827":"c5562d25"}[chunkId] + ".css";
};